<div class="confirm-dialog">
  <h3 mat-dialog-title>{{ (data.title ? data.title : 'lblConfirmation') | translate }}</h3>
  <div mat-dialog-content>
    <p>{{ data.message | translate }}</p>
  </div>
  <div mat-dialog-actions class="actions-dialog" align="end">
    <button matButton="filled" (click)="onYesClick()">{{ data.buttonYesText | translate }}</button>
    @if (data.buttonNoText) {
    <button matButton="outlined" (click)="onNoClick()">{{ data.buttonNoText | translate }}</button>
    }
  </div>
</div>
